const BASE_PATH = document.getElementsByTagName("base")?.[0]?.getAttribute("href") || "/";

export default BASE_PATH;
